module.exports = __webpack_public_path__ + "img/2026-05-03b_1.a8406e86.jpg";